import { getStorage } from '../models/Browser';
import React from 'react';
import { Row } from 'syngenta-digital-cropwise-react-ui-kit';
import { convertUom, parseUom } from './uom';
import { UNIT_SYSTEM_STORAGE_KEY } from '../modules/yield-analysis/store/useUnitSystemStore';

export const sentenceCase = (value: string) => {
  if (!value) return '';
  return value.charAt(0).toUpperCase() + value.slice(1).toLocaleLowerCase();
};

export const getFileNameFromURI = (uri: string) => {
  if (!uri) return '';
  const path = uri.split('/');
  const fullName = decodeURI(path[path.length - 1]);
  const underscoreIndex = fullName.indexOf('_');
  if (underscoreIndex === -1) return fullName;

  return fullName.substring(underscoreIndex + 1);
};

export const isEmptyOrSpaces = (str: string) => {
  return str === null || str.match(/^ *$/) !== null;
};

export const formatNumber = (num?: number, decimals: number = 2) =>
  num === undefined
    ? num
    : parseFloat(num.toFixed(decimals)).toLocaleString(undefined, { maximumFractionDigits: 2 });

export const DataRow = ({ title, value }: any) =>
  value ? (
    <Row key={title}>
      <span className="flex mr-4 text-neutral-60">{title}</span> {value ?? '-'}
    </Row>
  ) : null;

export const ConditionalWrapper = ({ condition, wrapper, children }: any) =>
  condition ? wrapper(children) : children;

export interface ValuesUnitSystem {
  yield: string;
  yieldVolume: string;
  wetWeight: string;
  area: string;
  productsApplied: string;
  appAvgRate: string;
  totalQty: string;
  moisture: string;
  plantAvgRate: string;
  plantAppliedRate: string;
  targetRate: string;
  cumulativePreciptation: string;
}

export const getUnitSystem = (unitSystem?: string): ValuesUnitSystem => {
  const system: string = unitSystem ?? getStorage(UNIT_SYSTEM_STORAGE_KEY);
  switch (system) {
    case 'METRIC':
      const metricUnits: ValuesUnitSystem = {
        yield: 'l1ha-1',
        yieldVolume: 'l1ha-1',
        wetWeight: 'kg1ha-1',
        area: 'ha',
        appAvgRate: 'l1ha-1',
        totalQty: 'l',
        productsApplied: 'l1ha-1',
        moisture: '%',
        plantAvgRate: 'seeds1ha-1',
        plantAppliedRate: 'seeds1ha-1',
        targetRate: 'seeds1ha-1',
        cumulativePreciptation: 'cm',
      };
      return metricUnits;

    default:
      const imperialUnits: ValuesUnitSystem = {
        yield: 'bu1ac-1',
        yieldVolume: 'bu1ac-1',
        wetWeight: 'lb1ac-1',
        area: 'ac',
        appAvgRate: 'gal1ac-1',
        totalQty: 'gal',
        productsApplied: 'gal1ac-1',
        moisture: '%',
        plantAvgRate: 'seeds1ac-1',
        plantAppliedRate: 'seeds1ac-1',
        targetRate: 'seeds1ac-1',
        cumulativePreciptation: 'in',
      };
      return imperialUnits;
  }
};

export const generateMeasureLabel = (value: number, uomIn: string, uomOut: string) => {
  return (
    <>
      {formatNumber(convertUom(value, uomIn, uomOut))} {parseUom(uomOut)}
    </>
  );
};
